import pathify from 'vuex-pathify'

pathify.options.mapping = 'standard'

export default pathify